<template>
    <button
        class="flex text-lg w-full text-left leading-6 font-medium truncate mb-0.5 py-1 px-3 rounded-xl"
        :class="(titleClass?titleClass:'') + (greyed?' text-gray-300':' text-gray-900')">
        <div class="flex-1" @click="$emit('click', $event)">
            <span class="inline-block font-bold mr-2" v-if="label">{{ label }} -</span>
            {{ title }}
        </div>
        <ui-toggle class="inline-block w-auto p-0.5 rounded-xl" field="text-xs"
                   v-if="type"
                   v-model="option.toggle"
                   :text="`Split `+type+`s`"
                   :field="greyed?' text-gray-300':' text-gray-900'"
                   @input="toggle"
        ></ui-toggle>
    </button>
</template>
<script>
import remoteStorage from "../../../../utils/remoteStorage";

export default {
    components: {},
    props: {
        titleClass: String,
        label: String,
        title: String,
        greyed: Boolean,
        breakdown: Object,
        type: String,
    },
    watch: {
        breakdown: {
            handler(data) {
                this.option.toggle = (this.type ? data['per' + this.type] : false)
            },
            deep: true,
        },
    },
    computed: {},
    data() {
        let data = remoteStorage.getItem('estimate-cost-list-toggles')
        if (this.type) {
            try {
                data = data ? JSON.parse(data) : {}
                if (!data) {
                    data = {};
                }
            } catch (e) {
                data = {};
            }
            if (!('per' + this.type in data)) {
                data['per' + this.type] = false;
            }
            Object.assign(this.breakdown, data)
        }
        return {
            breakdownData: this.breakdown,
            option: {toggle: (this.type ? data['per' + this.type] : false)},
        }
    },
    mounted() {
    },
    methods: {
        toggle(value) {
            this.breakdown['per' + this.type] = value
            this.updateData()
        },
        updateData() {
            remoteStorage.setItem('estimate-cost-list-toggles', JSON.stringify(this.breakdownData))
            this.$emit('changeBreakdown', this.breakdownData)
        },
    }
}
</script>
